<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon *ngIf="!isMoreInfo" nbPrefix icon="search-outline"></nb-icon>
          <nb-icon *ngIf="isMoreInfo" nbPrefix icon="person-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="{{
              isMoreInfo
                ? ('common.inputName' | translate)
                : ('common.strSearch' | translate)
            }}"
            [(ngModel)]="project.title"
            #title
          />
        </nb-form-field>

        <button
          nbButton
          hero
          status="info"
          size="small"
          (click)="create()"
          [disabled]="submitted || !project.title || project.title.length === 0"
          [class.btn-pulse]="submitted"
        >
          <nb-icon nbPrefix icon="save-outline"></nb-icon>
          {{ "buttons.save" | translate }}
        </button>

        <button
          nbButton
          outline
          shape="semi-round"
          status="primary"
          size="small"
          (click)="onNew()"
          [disabled]="loading"
          [class.btn-pulse]="loading"
        >
          <span>{{ "buttons.create" | translate }}</span>
        </button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div
        *ngFor="let item of projects | filter: project.title; let i = index"
        class="col-md-12"
      >
        <ngx-view-project
          [project]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-project>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>
</nb-card>
